module.exports = __webpack_public_path__ + "img/back-icon.7a2f3f59.svg";